export const MAX_TITLE_LENGTH = 80;
export const MAX_DESCRIPTION_LENGTH = 160;
export const MAX_ITEMS_LENGTH = 10;
export const MIN_ITEMS_LENGTH = 2;
